<template>
  <div class="cards-grid-container">
    <v-card
      v-for="(card, i) in cards"
      :key="'seller-card-' + i"
      class="card-data"
      :class="{ 'card-data-active': selectedCardIndex === i }"
      :elevation="0"
      :ripple="false"
      style="cursor: pointer"
      @mousedown="$emit('select-card', i)"
    >
      <v-card-text>
        <div class="card-content">
          <div class="card-icon">
            <v-icon :color="card.color" size="40">
              {{ card.icon }}
            </v-icon>
          </div>

          <div class="d-flex flex-column">
            <span class="card-title">{{ card.title }}</span>

            <div class="d-flex align-end mt-1">
              <span class="card-value" :style="{ color: card.color }">
                {{ card.value }}
              </span>
              <span class="card-unit ml-1">ราย</span>
            </div>

            <span v-if="card.subText" class="card-sub-text">
              {{ card.subText }}
            </span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "SellerCard",

  props: {
    sellersData: {
      type: Array,
      default: () => [],
    },
    selectedCardIndex: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    totalSellers() {
      return this.sellersData.length || 0;
    },

    sellersWithActiveProduct() {
      return this.sellersData.filter((s) => this.getActiveProductCount(s) > 0)
        .length;
    },

    sellersWithoutProduct() {
      return this.sellersData.filter((s) => this.getActiveProductCount(s) === 0)
        .length;
    },

    activePercent() {
      if (!this.totalSellers) return 0;
      return Math.round(
        (this.sellersWithActiveProduct / this.totalSellers) * 100
      );
    },

    noProductPercent() {
      if (!this.totalSellers) return 0;
      return Math.round(
        (this.sellersWithoutProduct / this.totalSellers) * 100
      );
    },

    cards() {
      return [
        {
          key: "all_sellers",
          title: "ผู้ขายทั้งหมด",
          icon: "mdi-store-outline",
          color: "#0EA5E9",
          value: this.totalSellers,
          subText:
            this.totalSellers > 0
              ? `รวมผู้ขายทั้งหมด ${this.totalSellers} ราย`
              : "",
        },
        {
          key: "sellers_with_product",
          title: "ผู้ขายที่มีสินค้าขายอยู่",
          icon: "mdi-basket-check-outline",
          color: "#10B981",
          value: this.sellersWithActiveProduct,
          subText:
            this.totalSellers > 0
              ? `คิดเป็น ${this.activePercent}% ของผู้ขายทั้งหมด`
              : "",
        },
        {
          key: "sellers_without_product",
          title: "ผู้ขายที่ยังไม่เคยลงสินค้าเลย",
          icon: "mdi-package-variant-closed",
          color: "#F59E0B",
          value: this.sellersWithoutProduct,
          subText:
            this.totalSellers > 0
              ? `คิดเป็น ${this.noProductPercent}% ของผู้ขายทั้งหมด`
              : "",
        },
      ];
    },
  },

  methods: {
    getActiveProductCount(seller) {
      const count =
        seller.activeProductsCount ??
        seller.active_products_count ??
        seller.activeProducts ??
        seller.active_products ??
        seller.productCount ??
        seller.products_count ??
        0;

      const num = Number(count);
      return Number.isNaN(num) ? 0 : num;
    },
  },
};
</script>

<style scoped>
.cards-grid-container {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}
@media (max-width: 1023px) {
  .cards-grid-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 600px) {
  .cards-grid-container {
    grid-template-columns: 1fr;
  }
}
.card-data {
  border-radius: 16px;
  border: 1px solid #f3f5f7;
  background: #ffffff;
  min-height: 120px;
  display: flex;
  align-items: center;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out,
    border-color 0.2s ease-in-out;
}
.card-data:hover {
  transform: scale(1.02);
  z-index: 10;
  background-color: #f9fafb;
  border-color: #d1d5db;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.04);
}
.card-data-active {
  background: #e0f2fe;
  border: 1px solid #38bdf8;
  box-shadow: 0 6px 16px rgba(56, 189, 248, 0.25);
  transform: translateY(-2px);
}
.card-content {
  display: flex;
  align-items: center;
  gap: 12px;
}
.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}
.card-value {
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}
.card-unit {
  font-size: 14px;
  font-weight: 400;
  color: #6b717f;
}
.card-sub-text {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #9ca3af;
}
</style>